import React, { useState, useRef } from 'react';
import PortalDropdown from './PortalDropdown';
import Icon from '../AppIcon';

/**
 * Generic status filter dropdown (same look as the one shipped on Factures reçues:
 * button + PortalDropdown + coloured dot + "Tous" option).
 *
 * Driven entirely by props so it can be reused on any list page:
 *   options  — [{ value, label, dot? }]  dot is a CSS colour string (hex/rgb/var)
 *   value    — currently selected option value
 *   onChange — (value) => void
 *
 * PortalDropdown closes itself on item click, so onClick only reports the value.
 */
const StatusFilterDropdown = ({ options = [], value, onChange, align = 'left', width = 200 }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = options?.find((o) => o?.value === value) || options?.[0];
  if (!current) return null;

  return (
    <div className="relative">
      <button
        ref={ref}
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs border border-gray-200 rounded-md bg-white hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary/20 transition-colors"
      >
        {current?.dot && <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: current?.dot }} />}
        <span className="text-gray-700">{current?.label}</span>
        <Icon name="ChevronDown" size={12} className="text-gray-400" />
      </button>
      <PortalDropdown
        anchorRef={ref}
        open={open}
        onClose={() => setOpen(false)}
        align={align}
        width={width}
        items={options?.map((o) => ({
          label: o?.label,
          dot: o?.dot || undefined,
          active: o?.value === value,
          onClick: () => onChange(o?.value),
        }))}
      />
    </div>
  );
};

export default StatusFilterDropdown;
